import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEventData,
} from "@hermes/utils/analytics";

export const CLOSE_CHAT = "End";
export const DISPLAY_AUTOMATIC_BUBBLE = "Display automatic";
export const DISPLAY_ERROR_BUBBLE = "Display error";
export const ENGAGED = "Engaged";
export const FIRST_MESSAGE = "First message";
export const LAUNCH_CHAT = "Launch chat";
export const SUBMIT_CHAT = "Continue button";

/**
 * Class for livechat event
 */
export class LivechatEvent implements AnalyticsEvent<GTMEventData | undefined> {
    /**
     * Event name expected for every impression event
     */
    public name: string = EVENT_UAEVENT;

    /**
     * Event's data from component to format correctly impression event
     */
    public eventData: { eventType: string; eventLabel: string };

    constructor(data: { eventType: string; eventLabel: string }) {
        this.eventData = data;
    }

    /**
     * Return event formatted to send to GTM
     */
    public formatForGTM(): GTMEventData | undefined {
        switch (this.eventData.eventType) {
            case DISPLAY_AUTOMATIC_BUBBLE: {
                return {
                    ...this.getCommonAttributes(),
                    eventaction: DISPLAY_AUTOMATIC_BUBBLE,
                    eventlabel: this.eventData.eventLabel,
                };
            }
            case DISPLAY_ERROR_BUBBLE: {
                return {
                    ...this.getCommonAttributes(),
                    eventaction: DISPLAY_ERROR_BUBBLE,
                    eventlabel: this.eventData.eventLabel,
                };
            }
            case LAUNCH_CHAT: {
                return {
                    ...this.getCommonAttributes(),
                    eventaction: LAUNCH_CHAT,
                    eventlabel: this.eventData.eventLabel,
                };
            }
            case FIRST_MESSAGE: {
                return {
                    ...this.getCommonAttributes(),
                    eventaction: FIRST_MESSAGE,
                    eventlabel: this.eventData.eventLabel,
                };
            }
            case ENGAGED: {
                return {
                    ...this.getCommonAttributes(),
                    eventaction: ENGAGED,
                    eventlabel: this.eventData.eventLabel,
                };
            }
            case SUBMIT_CHAT: {
                return {
                    ...this.getCommonAttributes(),
                    eventaction: SUBMIT_CHAT,
                    eventlabel: this.eventData.eventLabel,
                };
            }
            case CLOSE_CHAT: {
                return {
                    ...this.getCommonAttributes(),
                    eventaction: CLOSE_CHAT,
                    eventlabel: this.eventData.eventLabel,
                };
            }
            default: {
                return undefined;
            }
        }
    }

    public getCommonAttributes(): GTMEventData {
        return {
            event: this.name,
            eventcategory: "Chat",
        };
    }
}
